import { KYMW2500Model } from '../kymw2500.model';
import { PagenationRequestModel } from '../vo/pagenation-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページネーション詳細取得覧取得コマンド
 * サーバーにページネーション詳細情報をリクエストし、結果を表示する。
 *
 * @export GetPagenationDetailService
 * @class GetPagenationDetailService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPagenationDetailService extends PlessJsonResponderSub<any> {
  private model: KYMW2500Model = null;
  private vo: PagenationRequestModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPagenationDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MediumType: this.vo.MediumType,
        OrderCode: this.vo.OrderCode,
        CoopCode: this.vo.CoopCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2500Model} model モデルクラス
   * @param {PagenationRequestModel} vo ページネーションリクエストVO
   * @memberof GetPagenationDetailService
   */
  execute(model: KYMW2500Model, vo: PagenationRequestModel) {
    this.model = model;
    this.vo = vo;
    this.send('getPagenationDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPagenationDetailService
   */
  success(data: any) {
    // データグリッド「ページネーション一覧設定」を更新
    this.model.updatePagenationDetail(data, this.vo);
    // ページネーション詳細のヘッダ情報を更新
    this.model.kymw2500Component.setPagenationDetaiHeader(this.vo.OrderCode, this.vo.CoopCode);
  }
}
